import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { m } from "#/paraglide/messages";
import { PcrInputPage } from "#/components/pages/pcr-input/pcr-input-page";
import { PcrInputQueueView } from "#/components/pages/pcr-input/pcr-input-queue-view";

const PcrInputSearchSchema = z.object({
  pcrUploadId: z.unknown(),
});

export const Route = createFileRoute("/$tenantCode/$market/pcr-input")({
  beforeLoad: () => ({ getTitle: () => m["resources.pcrInput.name"]() }),
  validateSearch: PcrInputSearchSchema,
  component: PcrInputRoute,
});

function PcrInputRoute() {
  const { pcrUploadId } = Route.useSearch();

  if (typeof pcrUploadId !== "number") {
    return <PcrInputPage variant="notFound" />;
  }

  return <PcrInputQueueView pcrUploadId={pcrUploadId} />;
}
